import generatedGitInfo from "generatedGitInfo.json";
import { siteSettings } from "core/siteSettings";

export default function getFrontEndVersion(
  justVersion: boolean = false
): string {
  let versionString = "problem generating version string";
  if (generatedGitInfo?.gitCommitHash) {
    if (generatedGitInfo?.gitBranch) {
      versionString = `${siteSettings.frontEndVersion} - ${generatedGitInfo.gitCommitHash} (${generatedGitInfo.gitBranch})`;
    }
  }

  if (justVersion) {
    return versionString;
  }
  const longText = `version: ${versionString}`;
  return longText;
}
